<div class="m-input-group">
    <input
        class="p-inputtext"
        #textInput
        [(ngModel)]="searchText"
        [debounceTime]="200"
        (appDebounce)="filter($event)"
        (focus)="(true)"
        placeholder="{{ placeholder | translate }}"
        type="text"
    />

    <div class="m-input-group-addon">
        @if (!searchText) {
            <i
                class="fa fa-search"
                aria-hidden="true"
            ></i>
        }

        @if (searchText) {
            <button
                class="m-btn m-btn-square"
                (click)="clearFilter()"
                style="min-height: unset"
                type="button"
            >
                <i
                    class="fa fa-times"
                    aria-hidden="true"
                ></i>
            </button>
        }
    </div>
</div>
